import React from "react";
import { cn } from "../../DashboardPage/lib/utils";

interface DetailFieldProps {
  label: React.ReactNode;
  value: React.ReactNode;
  className?: string;
}

/**
 * Read-only label/value pair for detail views: a small muted uppercase label
 * above the value. Shared so every detail grid in the app reads the same.
 */
export default function DetailField({
  label,
  value,
  className,
}: DetailFieldProps) {
  return (
    <div className={cn("min-w-0", className)}>
      <dt className="text-xs font-medium tracking-wide uppercase text-neutral-500">
        {label}
      </dt>
      <dd className="mt-1 text-sm text-black break-words">
        {value === "" || value === null || value === undefined ? "—" : value}
      </dd>
    </div>
  );
}
